export default __webpack_public_path__ + "static/media/map-marker-empty.4ab5dec3.svg";